import React from 'react';
import {Button, List, ListItem, ListItemButton, ListItemText} from '@mui/material';
import {Link} from 'react-router-dom';

const SelectableRightDrawer = ({
  categories,
  selected,
  setSelected
}: {
  categories: {className: string}[];
  selected: {[key: string]: boolean};
  setSelected: React.Dispatch<
    React.SetStateAction<{
      [key: string]: boolean;
    }>
  >;
}) => {
  return (
    <List>
      {categories.map((category) => (
        <ListItem key={category.className} disablePadding>
          <ListItemButton
            onClick={() => setSelected((selected) => ({...selected, [category.className]: !selected[category.className]}))}
            sx={{backgroundColor: selected[category.className] ? 'rgba(256, 0, 128, 0.3)' : ''}}
          >
            <ListItemText primary={category.className} />
          </ListItemButton>
        </ListItem>
      ))}
    </List>
  );
};

export default SelectableRightDrawer;
